// This file is part of Coog. The COPYRIGHT file at the top level of
// this repository contains the full copyright notices and license terms.

import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { CSS_UID } from './index.utils';

import './index.scss';

/**
 * Field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const ConfirmationCommon = ({ label, disabled, isBtnOpen, handlerMainButton, children }) => (
  <div className={cn(CSS_UID)}>
    {isBtnOpen ? (
      children
    ) : (
      <button
        className={cn(`button button-primary`, { disabled })}
        type="button"
        disabled={disabled}
        onClick={handlerMainButton}
      >
        {label}
      </button>
    )}
  </div>
);
ConfirmationCommon.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isBtnOpen: PropTypes.bool,
  handlerMainButton: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

ConfirmationCommon.defaultProps = {
  disabled: false,
  isBtnOpen: false,
};

export default ConfirmationCommon;
